import React from 'react';
import { Globe, Lock, Users } from 'lucide-react';

interface VisibilityBadgeProps {
  /** New 3-state visibility: 'private' | 'team' | 'public' */
  visibility?: string;
  /** @deprecated Use visibility instead. Kept for backward compatibility. */
  isPublic?: boolean;
}

const VisibilityBadge: React.FC<VisibilityBadgeProps> = ({ visibility, isPublic }) => {
  // Resolve visibility from either prop, with backward compatibility
  const resolvedVisibility: string =
    visibility ?? (isPublic ? 'public' : 'private');

  if (resolvedVisibility === 'public') {
    return (
      <span
        className="inline-flex items-center gap-1 px-2 py-0.5 text-xs font-medium rounded-full bg-green-100 text-green-800 dark:bg-green-900/30 dark:text-green-400"
        aria-label="Public"
      >
        <Globe className="w-3 h-3" aria-hidden="true" />
        Public
      </span>
    );
  }

  if (resolvedVisibility === 'team') {
    return (
      <span
        className="inline-flex items-center gap-1 px-2 py-0.5 text-xs font-medium rounded-full bg-blue-100 text-blue-800 dark:bg-blue-900/30 dark:text-blue-400"
        aria-label="Team"
      >
        <Users className="w-3 h-3" aria-hidden="true" />
        Team
      </span>
    );
  }

  // Default: private
  return (
    <span
      className="inline-flex items-center gap-1 px-2 py-0.5 text-xs font-medium rounded-full bg-gray-100 text-gray-600 dark:bg-gray-700 dark:text-gray-400"
      aria-label="Private"
    >
      <Lock className="w-3 h-3" aria-hidden="true" />
      Private
    </span>
  );
};

export default VisibilityBadge;
